import { format, isToday, isTomorrow, parseISO } from 'date-fns'
import moment from 'moment'
import i18n from '@/i18n'

function translate(key, params) {
  return i18n.global.t(key, params)
}

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp * 1000)
  const time = format(date, 'hh:mm a')
  if (isToday(date)) {
    return translate('common.dates.today-at', { time })
  }
  return translate('common.dates.date-at', {
    date: format(date, 'MM/dd/yyyy'),
    time,
  })
}

export function formatTime(time, timeFormat = 'h:mma') {
  const end = moment(time)

  return end.utcOffset(end._tzm)
    .format(timeFormat)
}

export function formatDate(dateString) {
  const date = parseISO(dateString)

  if (isToday(date)) {
    return translate('common.dates.today')
  }
  if (isTomorrow(date)) {
    return translate('common.dates.tomorrow')
  }

  return format(date, 'MM/dd/yyyy')
}

export function formatDeliveryWindow(eta = {}) {
  const { from, to } = eta

  if (!from && !to) {
    return translate('common.dates.before-time', { time: '9:00 PM' })
  }
  if (from && !to) {
    return translate('common.dates.time-until', { from, time: '9:00 PM' })
  }
  if (!from && to) {
    return translate('common.dates.time-from', { time: '8:00 AM', to })
  }

  return null
}

export function unavailableDateLabel() {
  return translate('header.date-unavailable')
}

export function formatAptLabel() {
  return translate('common.dates.apt')
}

export function formatUSDate(dateString) {
  const date = parseISO(dateString)
  return format(date, 'MM/dd/yyyy')
}

export function formatUSDateTime(dateTimeString) {
  const date = new Date(dateTimeString)
  let hours = date.getHours()
  let minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours %= 12
  hours = hours || 12
  minutes = minutes < 10 ? `0${minutes}` : minutes
  const strTime = `${hours}:${minutes} ${ampm}`
  return `${strTime} ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

export function convertTime24to12(time24h) {
  if (typeof time24h !== 'string') {
    return ''
  }

  const normalizedTime = time24h.trim()
  const match = normalizedTime.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)

  if (!match) {
    return normalizedTime
  }

  const hours = parseInt(match[1], 10)
  const ampm = hours >= 12 ? 'PM' : 'AM'

  return `${hours % 12 || 12}:${match[2]} ${ampm}`
}

export function estimatedMinutesToTime(estimatedMinutes) {
  const now = new Date()
  now.setMinutes(now.getMinutes() + estimatedMinutes)

  const hours = now.getHours()
  const minutes = now.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes

  return `${formattedHours}:${formattedMinutes} ${ampm}`
}

export function formatPhoneNumber(number) {
  const str = number.toString()
  return str.replace(/(\+\d)(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4')
}

export function removeSecondsFromTime(timeWithSeconds) {
  const [hours, minutes] = timeWithSeconds.split(':')
  return `${hours}:${minutes}`
}

export async function awaitCondition(condition, timeout = 200) {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const cond = condition()
      if (cond === false) return
      clearInterval(interval)
      if (cond instanceof Promise) {
        cond
          .then(data => resolve(data))
          .catch(data => reject(data))
      } else {
        resolve(cond)
      }
    }, timeout)
  })
}
